import React from "react";
import { documentenTab } from "../../function";
import CardDocument from "../../Componenten/Cards/CardDocument";

const Documents = () => {
  return (
    <div className="min-h-0 bg-wa-app px-4 pb-10 pt-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <header className="mb-6 sm:mb-8">
          <h1 className="text-xl font-semibold tracking-tight text-wa-text sm:text-2xl">
            Documenten
          </h1>
          <p className="mt-1 max-w-2xl text-sm text-wa-muted sm:text-[15px]">
            Adviezen, plannen en uploads — alles op één plek, voor elk scherm.
          </p>
        </header>
        <ul
          className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 xl:grid-cols-3 xl:gap-6"
          role="list"
        >
          {documentenTab().map((item) => (
            <li key={item.id} className="min-w-0">
              <CardDocument item={item} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Documents;
